var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 23.823,
    viewBox: "0 0 27 23.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -30.125)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.961,142.873a14.9,14.9,0,0,1-6.118,2.633,3.376,3.376,0,0,1-6.686,0,14.9,14.9,0,0,1-6.118-2.633A9.241,9.241,0,0,1,0,135.5v14.37a3.9,3.9,0,0,0,3.9,3.9H23.1a3.9,3.9,0,0,0,3.9-3.9V135.5A9.241,9.241,0,0,1,22.961,142.873Z",
    transform: "translate(0 -99.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.541,44.065V42.628a.791.791,0,0,1,.791-.791H44.5a.791.791,0,0,1,.791.791v1.437c4.932-1.071,8.541-4.423,8.541-8.383v-.791H47.475V33.319a3.2,3.2,0,0,0-3.194-3.194H39.555a3.2,3.2,0,0,0-3.194,3.194v1.572H30v.791C30,39.642,33.609,42.994,38.541,44.065Zm-.6-10.746a1.614,1.614,0,0,1,1.612-1.612h4.726a1.614,1.614,0,0,1,1.612,1.612v1.572h-7.95V33.319Z",
    transform: "translate(-28.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M225.555,282.215h-3.59v1.795a1.795,1.795,0,0,0,3.59,0Z",
    transform: "translate(-210.26 -238.796)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.f3c94fb8abd9d14585958544a9d285d8.svg";
export { ForwardRef as ReactComponent };